export default "__VITE_ASSET__DuqrJyp6__"